var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meeting-invite-form" }, [
    _c(
      "form",
      {
        ref: "form",
        attrs: { method: "post" },
        on: {
          submit: function($event) {
            _vm.onSubmit($event)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c(
              "md-field",
              { class: { "md-invalid": !!_vm.errors["lastname"] } },
              [
                _c("md-input", {
                  attrs: {
                    placeholder: _vm.$t("meeting-invite.lastname"),
                    name: "lastname",
                    disabled: _vm.submitting ? "disabled" : null,
                    required: "",
                    autofocus: ""
                  },
                  model: {
                    value: _vm.fData.lastname,
                    callback: function($$v) {
                      _vm.$set(_vm.fData, "lastname", $$v)
                    },
                    expression: "fData.lastname"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "md-error" }, [
                  _vm._v(
                    _vm._s(
                      _vm.errors["lastname"] ? _vm.errors["lastname"][0] : ""
                    )
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "md-field",
              { class: { "md-invalid": !!_vm.errors["firstname"] } },
              [
                _c("md-input", {
                  attrs: {
                    placeholder: _vm.$t("meeting-invite.firstname"),
                    name: "firstname",
                    disabled: _vm.submitting ? "disabled" : null,
                    required: "",
                    autofocus: ""
                  },
                  model: {
                    value: _vm.fData.firstname,
                    callback: function($$v) {
                      _vm.$set(_vm.fData, "firstname", $$v)
                    },
                    expression: "fData.firstname"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "md-error" }, [
                  _vm._v(
                    _vm._s(
                      _vm.errors["firstname"] ? _vm.errors["firstname"][0] : ""
                    )
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c(
              "md-field",
              { class: { "md-invalid": !!_vm.errors["email"] } },
              [
                _c("md-input", {
                  attrs: {
                    placeholder: _vm.$t("meeting-invite.email"),
                    name: "email",
                    disabled: _vm.submitting ? "disabled" : null,
                    autofocus: ""
                  },
                  model: {
                    value: _vm.fData.email,
                    callback: function($$v) {
                      _vm.$set(_vm.fData, "email", $$v)
                    },
                    expression: "fData.email"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "md-error" }, [
                  _vm._v(
                    _vm._s(_vm.errors["email"] ? _vm.errors["email"][0] : "")
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c("phone-field", {
              ref: "phoneInput",
              attrs: {
                "show-label": false,
                required: "",
                name: "phone",
                errors: _vm.errors["phone"],
                label: _vm.$t("meeting-invite.phone"),
                "country-id": "1",
                disabled: _vm.submitting ? "disabled" : null
              },
              model: {
                value: _vm.fData.phone,
                callback: function($$v) {
                  _vm.$set(_vm.fData, "phone", $$v)
                },
                expression: "fData.phone"
              }
            }),
            _vm._v(" "),
            _c(
              "md-field",
              { class: { "md-invalid": !!_vm.errors["company"] } },
              [
                _c("md-input", {
                  attrs: {
                    placeholder: _vm.$t("meeting-invite.company"),
                    name: "company",
                    disabled: _vm.submitting ? "disabled" : null,
                    autofocus: ""
                  },
                  model: {
                    value: _vm.fData.company,
                    callback: function($$v) {
                      _vm.$set(_vm.fData, "company", $$v)
                    },
                    expression: "fData.company"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "md-error" }, [
                  _vm._v(
                    _vm._s(
                      _vm.errors["company"] ? _vm.errors["company"][0] : ""
                    )
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("submit-button", {
          staticClass: "registration-standalone-button",
          attrs: {
            type: "submit",
            submitting: _vm.submitting,
            label: _vm.$t("meeting-invite.register")
          },
          on: {
            click: function($event) {
              _vm.onSubmit()
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b1feafe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b1feafe","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/MeetingInviteForm.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7b1feafe","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/MeetingInviteForm.vue
// module chunks = 1 2 3